let _ = require('../_.js');
var $ = jQuery;


// Helper functions that dont execute on init, but are used globally in the app.

// * This file should be equal to 'functions.js' in both wordpress and the admin site. *

// Generates a unique indentifier for this session prefixed with uid
var idCounter = 0;
_.uniqueId = function (prefix = 'uid') {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
}

// Put this in the code for sanity check failures
_.shouldnt_happen = function (context) {
    console.error("Shouldn't happen code executed", context);
    console.trace();
}

// Scroll an overflow element so target becomes visible
_.scrollIntoViewIfNeeded = function (target) {
    var $target = $(target);

    // Find the closest parent with overflow-y: auto
    var $parent = $target.parent();

    // Calculate the absolute top position of the target
    var targetTop = $target.position().top + $parent.scrollTop();

    var targetHeight = $target.outerHeight();
    var parentHeight = $parent.height();
    var scrollPosition = $parent.scrollTop();

    // Check if the target is out of view
    if (targetTop < scrollPosition || targetTop + targetHeight > scrollPosition + parentHeight) {
        console.log("Scrolling!", targetTop)

        // Calculate the new scroll position to center the target
        var newScrollPosition = targetTop + targetHeight / 2 - parentHeight / 2;

        // Limit the scroll position between 0 and the maximum scrollable height
        newScrollPosition = Math.max(0, Math.min(newScrollPosition, $parent[0].scrollHeight - parentHeight));

        // Scroll the parent to the new scroll position
        $parent.scrollTop(newScrollPosition);
    }
}

_.scrollPageIntoViewIfNeeded = function (target) {
    var $target = $(target);

    // Calculate the absolute top position of the target relative to the document
    var targetTop = $target.offset().top;

    var targetHeight = $target.outerHeight();
    var windowHeight = $(window).height();
    var windowScrollPosition = $(window).scrollTop();

    // Check if the target is out of view
    if (targetTop < windowScrollPosition || targetTop + targetHeight > windowScrollPosition + windowHeight) {
        console.log("Scrolling!", targetTop)

        // Calculate the new scroll position to center the target
        var newScrollPosition = targetTop + targetHeight / 2 - windowHeight / 2;

        // Animate the scroll to the new position
        $('html, body').animate({
            scrollTop: newScrollPosition
        }, 1000); // duration of the scroll animation in milliseconds
    }
}

_.addPaddingEqualToScrollbarWidth = function (selector) {
    var $element = $(selector);

    // Calculate the scrollbar's width
    var scrollbarWidth = $element.outerWidth() - $element[0].clientWidth;

    // Get the original left padding, if it hasn't been saved yet
    if (!$element.data('original-padding-left')) {
        $element.data('original-padding-left', parseFloat($element.css('padding-left')));
    }

    // Calculate the new left padding
    var newPaddingLeft = $element.data('original-padding-left') + scrollbarWidth;

    // Get the current left padding
    var currentPaddingLeft = parseFloat($element.css('padding-left'));

    // Set the new left padding only if it's different from the current padding
    if (newPaddingLeft !== currentPaddingLeft) {
        $element.css('padding-left', newPaddingLeft);
    }
}



// Add :hasCSS() selector to jQuery
$.expr[':'].hasCSS = function (el, index, props) {
    var property = props[3].split(',')[0];
    var value = props[3].split(',')[1];
    return $(el).css(property) == value;
};

// Like .split(), but the final element will contain the remaining string, like php explode
String.prototype.explode = function (delimiter, max) {
    if (max === undefined) {
        return this.split(delimiter);
    } else {
        let splitArray = this.split(delimiter);
        if (splitArray.length > max) {
            let remainder = splitArray.splice(max - 1).join(delimiter);
            splitArray.push(remainder);
        }
        return splitArray;
    }
};

// htmlescapechars in js
_.htmlescape = function (str) {
    if (str === null || str === undefined) {
        return '';
    }
    var escapedString = String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    return escapedString;
}

// "First Last" of a record with first_name / last_name, either of which may be null or ''
_.full_name = function (person) {
    return [person.first_name, person.last_name].filter(Boolean).join(' ');
}

// alias encodeURIComponent to urlencode for ease
_.urlencode = function (str) {
    return encodeURIComponent(str);
}

// Returns true if a scrollbar is visible.
_.hasVerticalScrollbar = function () {
    // Get the height of the entire document
    const documentHeight = Math.max(
        document.documentElement.clientHeight,
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight
    );

    // Get the height of the viewport
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    // Compare the document height and viewport height to check if a scrollbar is present
    return documentHeight > viewportHeight;
}

// Return true if browser sized xs
_.isMobileViewport = function () {
    return window.innerWidth < 1050;
}

_.isMobileUserAgent = function () {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);
    return isIOS || isAndroid;
}

_.isMobileDevice = function () {
    return window.innerWidth <= 768;
}

_.getOS = function () {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    let isMobile = _.isMobileDevice();

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1 && isMobile) {
        os = 'iPhone';
    } else if (iosPlatforms.indexOf(platform) !== -1 && !isMobile) {
        os = 'iPad';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent) && isMobile) {
        os = 'Android-Phone';
    } else if (/Android/.test(userAgent) && !isMobile) {
        os = 'Android-Tablet';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    } else {
        os = 'Unknown';
    }

    return os;
}

_.isCrawler = function () {
    let userAgent = navigator.userAgent;
    let botPattern = /bot|spider|crawl|slurp|archiver|ping|search|dig|tracker|monitor|snoopy|yahoo|baidu|msn|ask|teoma|axios/i;

    return botPattern.test(userAgent);
}


// Wait for all img tags to load before callback
_.waitForImages = function (callback) {
    var $images = $('img'); // Get all img tags
    var totalImages = $images.length;
    var imagesLoaded = 0;

    if (totalImages === 0) {
        callback(); // if there are no images, immediately call the callback
    }

    $images.each(function () {
        var img = new Image();
        img.onload = function () {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
                callback(); // call the callback when all images are loaded
            }
        };
        img.onerror = function () {
            imagesLoaded++;
            if (imagesLoaded === totalImages) {
                callback(); // also call the callback if an image fails to load
            }
        };
        img.src = this.src; // this triggers the loading
    });
}

_.formatPhoneNumber = function (phoneNumberString) {
    if (phoneNumberString === null || phoneNumberString === undefined) {
        return '';
    }
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    let match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumberString;
}

// Format a number as dollars
_.currency = function (num) {
    if (num === null) {
        return '---';
    }

    if (typeof (num) == 'string') {
        num = parseFloat(num);  // Convert string to float regardless of the presence of a decimal
    }

    // Round the number to two decimal places and convert to string
    let strNum = num.toFixed(2);
    if (strNum.endsWith('.00')) {
        strNum = strNum.substring(0, strNum.length - 3);

        // Split the string into whole and decimal parts

        let result = '';
        let count = 0;
        // Reverse the whole number part for easier manipulation
        for (let i = strNum.length - 1; i >= 0; i--) {
            count++;
            result = strNum.charAt(i) + result;
            if (count % 3 === 0 && i !== 0) {
                result = ',' + result;
            }
        }

        // Reattach the decimal part
        result = result;
        return '$' + result;
    } else {

        // Split the string into whole and decimal parts
        let parts = strNum.split('.');
        let whole = parts[0];
        let decimal = parts[1];

        let result = '';
        let count = 0;
        // Reverse the whole number part for easier manipulation
        for (let i = whole.length - 1; i >= 0; i--) {
            count++;
            result = whole.charAt(i) + result;
            if (count % 3 === 0 && i !== 0) {
                result = ',' + result;
            }
        }

        // Reattach the decimal part
        result = result + '.' + decimal;
        return '$' + result;
    }
}


// Format a number as percentage
_.percentage = function (num) {

    if (num === null) {
        return "---";
    }

    num = String(num).replace("%", "");

    return num + "%";
}

_.float = function (val) {
    if (val) {
        return parseFloat(val);
    } else {
        return parseFloat(0);
    }
}

_.finishAllAnimations = function () {
    $("*").stop(true, true);
    var elements = document.querySelectorAll('.animated'); // select all elements with the 'animated' class
    for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        var newone = el.cloneNode(true);
        el.parentNode.replaceChild(newone, el);
    }
}

// Same as php ucwords - capitalize first letter of each word
_.ucwords = function (input) {
    return input.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

// Returns a function that when called, calls the provided decorator function. 
// Read inner comment for explanation.
_.decorated = function (context, decorator_unique_name, callback) {
    // There are many functions in this codebase such as _.debounce or _.exclusive that when called,
    // produce a new function which has the desired effect.  For example, you could make a search function
    // that only called once every second at most with:
    //      let mySearchFunction = _.debounce(1000, function(searchTerms) { /* Do things */ return null; });
    // And while this works, it doesn't let you redefine the behaviors for class methods.
    // This function, when called, will define a function in its own database of functions with the provded
    // decorator function if it has not yet been defined, and then call it.  So our search function in a class
    // now could be setup like:
    //      static mySearchFunction { 
    //          return _.decorate(
    //              theClassName (don't use this on static functions, sometimes this could be the wrong value if something else rebound the function)
    //              "mySearchFunction", 
    //              _.debounce(1000, function(searchTerms) { /* Do things */ return null; });,\
    //          )
    //      }
    // - and now the effect works as intended in a class method.

    if (!context._decorators) {
        context._decorators = {};
    }

    if (!context._decorators[decorator_unique_name]) {
        context._decorators[decorator_unique_name] = callback;
    }

    return context._decorators[decorator_unique_name].bind(context)();
}

_.extract_error = function (error) {
    console.error(error);

    // Check if this is a network/connection error
    function isNetworkError(err) {
        if (!err) return false;

        // Check for common network error indicators
        if (err.status === 0 || err.statusText === 'error') return true;
        if (err.status >= 500 && err.status < 600) return true;
        if (typeof err === 'string' && (
            err.includes('Network Error') ||
            err.includes('Connection refused') ||
            err.includes('Failed to fetch') ||
            err.includes('ERR_CONNECTION')
        )) return true;

        return false;
    }

    // Check if a string looks like code (function definitions, minified code, etc.)
    function looksLikeCode(str) {
        if (!str || typeof str !== 'string') return false;

        // Check for function definitions, excessive brackets/parens, or minified code patterns
        const codePatterns = [
            /^function\s*\(/,                    // function(
            /^\([a-z,]+\)\s*=>/,                 // arrow functions
            /^[a-z]\.[a-z]\(/,                   // a.b( minified
            /\)\s*\{.*return/,                   // ){return pattern
            /&&.*\|\|/,                          // && || operators together
            /[a-z]\([a-z],[a-z]\)/,              // single letter function calls
            /^[a-z]{1,2}\|\|[a-z]{1,2}\./        // minified OR patterns
        ];

        return codePatterns.some(pattern => pattern.test(str));
    }

    // Recursively search for messages in objects/arrays
    function searchMessages(err, depth = 0) {
        if (depth >= 15) {
            return "";
        }
        let maxWords = "";
        if (typeof err === 'object' && err !== null) {
            for (let key in err) {
                if (key === 'error' || key === 'errors' || key === 'message') {
                    if (typeof err[key] === 'string' && !looksLikeCode(err[key])) {
                        return err[key];
                    } else if (typeof err[key] === 'object') {
                        return searchMessages(err[key], depth + 1);
                    }
                } else if (typeof err[key] === 'string' && !looksLikeCode(err[key])) {
                    let words = err[key].split(" ");
                    if (words.length > maxWords.split(" ").length && words.length < 50) {
                        maxWords = err[key];
                    }
                } else if (typeof err[key] === 'object') {
                    let nestedMessage = searchMessages(err[key], depth + 1);
                    if (nestedMessage && !looksLikeCode(nestedMessage)) {
                        let words = nestedMessage.split(" ");
                        if (words.length > maxWords.split(" ").length && words.length < 50) {
                            maxWords = nestedMessage;
                        }
                    }
                }
            }
        }
        return maxWords;
    }

    // A rejected promise's / event's payload, not the event (walking an Event reaches window and the
    // document's cross-origin stylesheets, whose cssRules throw)
    if (typeof Event !== 'undefined' && error instanceof Event) {
        error = error.reason ?? error.error ?? error.message ?? '';
    }

    // Check for network errors first
    if (isNetworkError(error)) {
        return "A network error has occurred. Please refresh the page if issues continue.";
    }

    if (error && error.reason && error.reason.error) {
        return error.reason.error;
    }

    // Handle different error formats
    // if (error instanceof PromiseRejectionEvent) {
    // error = error.reason;
    // }
    if (typeof error === 'object' && error !== null) {
        if (error.reason && typeof error.reason === 'string') {
            return "Error: " + error.reason;
        }
        if (error.responseJSON && error.responseJSON.error && error.responseJSON.error.file) {
            let file = error.responseJSON.error.file;
            let line = error.responseJSON.error.line;
            let message = error.responseJSON.error.message;
            if (!message) {
                return "Backend Exception: " + file + " line " + line;
            } else {
                return "Backend Exception: " + message;
            }
        }
        if (error.responseJSON) {
            error = error.responseJSON;
        }
        let extracted = searchMessages(error);
        if (extracted && !looksLikeCode(extracted)) {
            return extracted;
        }
    }
    if (typeof error === 'string') {
        if (looksLikeCode(error)) {
            return "An error has occurred. Please refresh the page if issues continue.";
        }
        return error;
    }
    if (error instanceof Error) {
        return error.toString();
    }
    if (Array.isArray(error)) {
        return error.map((item) => {
            if (typeof item === 'string' && !looksLikeCode(item)) {
                return item;
            } else {
                let msg = searchMessages(item);
                return (msg && !looksLikeCode(msg)) ? msg : "";
            }
        }).filter(msg => msg).join("\n");
    }

    return "An error has occurred. Please refresh the page if issues continue.";
}

// General function to display a error from ajax.
_.flash_error = function (error) {
    _.flash_alert(_.extract_error(error), 'danger', 'end');
}

// Used to output the contents of a textarea box into html, or similar.
_.escape_multiline_string = function (inputString) {
    return _.nl2br(inputString
        .replace(/&/g, '&amp;') // Escape &
        .replace(/</g, '&lt;') // Escape <
        .replace(/>/g, '&gt;') // Escape >
        .replace(/"/g, '&quot;') // Escape double quotes
        .replace(/'/g, '&#39;')); // Escape single quotes
}

_.nl2br = function (str) {
    return (str + '').replace(/[\r\n]/g, '<br />');
}

_.ymdhis_to_unix = function (strdate) {
    var date = new Date(strdate);
    return date.getTime() / 1000;
}

_.$geolookup_ip_link = function (ip) {
    if (ip && (ip.indexOf('192.168') === 0) || ip.indexOf('10.') === 0) {
        return $("<span>" + ip + " (local)</span>");
    } else if (ip) {
        return $("<a></a>").attr('target', '_blank').attr("href", "https://www.geolocation.com/?ip=" + ip + "#ipresult").text(ip);
    } else {
        return $("<span />");
    }
}

_.$admin_link = async function (user_id) {
    if (!user_id) {
        return $("<span>(none)</span>");
    }
    let user = await App_Models_User.get(user_id);
    if (user) {
        return $("<a></a>").text(
            user.first_name + " " + user.last_name
        ).attr("target", "_blank").attr("href", "/users/" + user.id);
    } else {
        return $("<span>Admin User " + user_id + "</span>");
    }
}

_.$nbsp = function () {
    return $("<span>&nbsp;</span>");
}

_.get_month_name = function (monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', { month: 'long' });
}

/**
 * Converts a duration from seconds to a human-readable format.
 *
 * @param {number} seconds The duration in seconds.
 * @returns {string} The formatted duration.
 *
 * The function returns:
 * - "X seconds" if the duration is less than 60 seconds,
 * - "X minutes and Y seconds" if less than 10 minutes,
 * - "X minutes" if less than 1 hour,
 * - "X hours and Y minutes" otherwise.
 */
_.durationToHuman = function (seconds, round_to_whole_value = false) {
    if (isNaN(seconds)) {
        return "---";
    }

    if (seconds < 60) {
        return `${seconds} seconds`;
    } else if (seconds < 600 && round_to_whole_value == false) {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = seconds % 60;
        return minutes + " minute" + (minutes > 1 ? "s" : "") + " and " + remainingSeconds + " seconds";
    } else if (seconds < 3600) {
        let minutes = Math.floor(seconds / 60);
        return minutes + " minute" + (minutes > 1 ? "s" : "");
    } else if (round_to_whole_value) {
        let hours = Math.floor(seconds / 3600);
        return hours + " hour" + (hours > 1 ? "s" : "");
    } else {
        let hours = Math.floor(seconds / 3600);
        let remainingSeconds = seconds % 3600;
        let minutes = Math.floor(remainingSeconds / 60);
        return hours + " hour" + (hours > 1 ? "s" : "") + " and " + minutes + " minute" + (minutes > 1 ? "s" : "");
    }
}

_.is_cachewarmer = function () {
    const userAgent = navigator.userAgent;
    const regex = /puppeteer/i;
    return regex.test(userAgent);
}

// Warns if the user is using an older web browser - specifically an older version of safari, all the rest of the major browsers have good auto update.
_.warnUnsupportedBrowser = function () {
    function checkWebRTCSupport() {
        return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
    }

    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var isDesktop = !(/iPhone|iPad|iPod/i.test(navigator.userAgent));
    var isAndroid = /android/i.test(navigator.userAgent);

    if (isSafari && isDesktop) {
        var match = navigator.userAgent.match(/Version\/(\d+)\.(\d+)/);
        if (match) {
            var majorVersion = parseInt(match[1]);

            if (majorVersion < 17) {
                alert("Your version of the Safari web browser is unsupported with AuctionCast. Please update Safari, or use an alternative web browser such as Firefox or Google Chrome to browse the site.");
            }
        }
    } else if (isAndroid && !checkWebRTCSupport()) {
        alert("Your web browser is unsupported with AuctionCast. Please use an alternative web browser such as Google Chrome to browse the site.");
    }
}
_.round_number = function (value, decimal_places = 0) {
    let num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return NaN;
    const factor = Math.pow(10, decimal_places);
    return Math.round(num * factor) / factor;
}

// Get ACE backend URL based on current environment
_.get_ace_backend_url = function() {
    let hostname = window.location.hostname;
    
    // Development environment detection
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        return 'http://ace.landproz.local';
    }
    
    // Staging/test environments (e.g., *.hanson.xyz)
    if (hostname.includes('hanson.xyz')) {
        // Extract subdomain prefix if exists
        let parts = hostname.split('.');
        if (parts.length > 3 && parts[0] !== 'www') {
            return `https://ace.${hostname}`;
        }
        return 'https://ace.landproz.claude.dev.hanson.xyz';
    }
    
    // Production
    return 'https://ace.landproz.com';
}
